"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateChildren = validateChildren;
function validateChildren(children, childType, message) {
  children.forEach(child => {
    if (child) {
      if (Array.isArray(child)) {
        validateChildren(child, childType, message);
      } else if (!childType.includes(child.type)) {
        console.error(message, children);
        return false;
      }
    }
  });
  return true;
}